import type { IconSvgObject } from './types';

const ScrollHorizontalIcon: IconSvgObject = [
  ["path", { d: "M14.0022 11.9959C14.0022 13.0993 13.1072 13.9937 12.003 13.9937C10.8989 13.9937 10.0039 13.0993 10.0039 11.9959C10.0039 10.8925 10.8989 9.99805 12.003 9.99805C13.1072 9.99805 14.0022 10.8925 14.0022 11.9959Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 16L2 12L8 8L6.5 12L8 16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 16L22 12L16 8L17.5 12L16 16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ScrollHorizontalIcon;
